import { Geography } from '@rbilabs/common';
import { useIntl } from 'react-intl';

import { IStore } from '@rbi-ctg/store';
import { IRestaurantNode } from 'generated/rbi-graphql';
import { useGeolocation } from 'state/geolocation';
import { useLocale } from 'state/intl';
import { StoreProxy } from 'state/store';
import { readableDistanceFromStore } from 'utils/restaurant';

interface UserDistanceTextOptions {
  restaurant: IRestaurantNode | IStore | StoreProxy;
}

export const useDistanceText = ({
  restaurant: { latitude, longitude },
}: UserDistanceTextOptions) => {
  const { activeCoordinates } = useGeolocation();
  const { formatMessage } = useIntl();
  const { region } = useLocale();

  let distanceText;

  if (activeCoordinates && latitude && longitude) {
    const distance = Geography.coordinateDistance(
      { latitude: activeCoordinates.lat, longitude: activeCoordinates.lng },
      {
        latitude,
        longitude,
      }
    );
    distanceText = readableDistanceFromStore(distance, region, formatMessage);
  }

  return distanceText;
};
